/* Import Global Libraries */
import Logger from './utils/Logger';

/**************************************
 * Class: EventLogger
 * Description: This class represents EventLogger.
 * Author: Gagandeep
 * Las Edit Date: 24/09/2019
 * Relase Version: 1.0
 **************************************/

const EventLogger = () => {
    const DEBUG = 1;
    const TRACE = 2;
    const INFO = 3;
    const WARNING = 4;
    const ERROR = 5;

    const that = {};
    that.eventLoggerToken = undefined;
    that.eventServer = {};
    that.logID = undefined;
    that.eventBuffer = new Array();
    that.uniqueSequence = 1;
    that.clientId = undefined;

    // ************************************
    // Public function: init()
    // Intializes EventLogger
    // ************************************

    that.init = (token) => {
        // conference token will be short lived and not persist here, as after validation, its life will expire
        // So this token will only passthrough for validation
        try {
            // let tokenObj = JSON.parse(window.atob(token));
            const tokenObj = token;

            // If server sent back Event Server details(url and port) with token, logging is turned ON else it is turned OFF
            if (tokenObj.eventServer && tokenObj.eventServer.url) {
                that.eventServer.url = tokenObj.eventServer.url;
                that.logID = tokenObj.logId;
                /*
                if(tokenObj.eventServer.url && tokenObj.eventServer.port){

                    xhttp.onreadystatechange = function() {
                        //console.log("readystate: " + this.readyState + " status: " + this.status + " responseText: " + this.responseText );
                        if (this.readyState == 4 && this.status == 200) {
                            //Logger.info(this.responseText);
                            that.eventLoggerToken = JSON.parse(this.responseText).eventLoggerToken;

                            //console.log('that.eventLoggerToken = ' + that.eventLoggerToken);
                            //localStorage.setItem('eventToken', that.eventLoggerToken);
                            that.processBufferEvents();

                        } else {
                            //Logger.error('Connection to Event Server did not establish. Status: ' + this.status + ' responseText' + this.responseText);
                        }
                    }
                    xhttp.open("POST", "https://" + tokenObj.eventServer.url + ":" + tokenObj.eventServer.port + "/init", true);

                    //xhttp.setRequestHeader("authorization", "123");
                    //xhttp.setRequestHeader("content-type", "application/json");
                    xhttp.setRequestHeader("token", window.btoa(JSON.stringify(token)));

                    xhttp.send();
                }
                */
            }
        } catch (e) {
            Logger.error(`Error! Failed to send auth request to Event Server. Error: ${e}.`);
        }
        // console.log("EVENT SERVER URL: " + that.eventServer.url + " Port: " + that.eventServer.port);
    };


    that.log = (level0, logEvent) => {
        try {
            // If server sent back Event Server details(url and port), logging is turned ON else it is turned OFF
            // console.log('EventLogger.log event ' + JSON.stringify(logEvent));

            // Create Event Object
            const sourceTimeStamp = new Date().toISOString();
            let level0Label = 'info';
            const eventObj = {};

            switch (level0) {
                case DEBUG:
                    level0Label = 'debug';
                    break;

                case TRACE:
                    level0Label = 'trace';
                    break;

                case INFO:
                    level0Label = 'info';
                    break;

                case WARNING:
                    level0Label = 'warning';
                    break;

                case ERROR:
                    level0Label = 'error';
                    break;

                default:
                    level0Label = 'info';
            }

            // Event Object structure that will eventually be published to the event server
            // Caution: If you are modifying this object's prototype (members),
            //    take care of the filtering and structuring of the information at the backend (event server and further) as well

            eventObj.key = {
                logID: that.logID,
                endpointType: 'client',
                instanceID: that.logID, // ToDo - TBD, This field is for Servers, TBD for clients, for now keep it as logID
                uniqueSequence: that.uniqueSequence++,
                //clientId: that.clientId? that.clientId: "undef"
            };

            if (logEvent.event) {
                eventObj.severity = logEvent.event.severity; // ToDo - Devise logic to auto determine severity. E.g. Critical, high, medium, low, none
            } else {
                eventObj.severity = 'none'; // default severity if no severity is available
            }

            eventObj.eventLevel = [];
            eventObj.eventLevel.push(level0Label);
            eventObj.eventLevel.push(logEvent.source);

            // eventMeta is a generic object, structure of which is left to the client and end-consumer of event logs
            // eventObj.eventMeta = logEvent;
            eventObj.eventMeta = {};
            eventObj.eventMeta.event = logEvent.event;
            eventObj.eventMeta.meta = logEvent.meta;

            eventObj.isAnonymousInfo = true;
            eventObj.sourceTimeStamp = sourceTimeStamp;

            if (that.eventServer.url && that.eventLoggerToken) {
                // POST event object to Event server if event server url port and Eventlogger token in available
                const xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState === 4 && this.status === 200) {
                        Logger.info(this.responseText);
                    } else {
                        Logger.error(`Connection to Event Server did not establish. readyState: ${this.readyState} Status: ${this.status}`);
                    }
                };
                xhttp.open('POST', `https://${that.eventServer.url}/event`, true);
                xhttp.setRequestHeader('Content-Type', 'application/json');
                xhttp.setRequestHeader('eventToken', that.eventLoggerToken);

                xhttp.send(JSON.stringify(eventObj));
            } else {
                // Else, store the log in a buffer till the time the token is available and POST once event server responds
                that.eventBuffer.push(eventObj);
            }
        } catch (e) {
            Logger.error(`Error! Failed to post log event to Event Server. Error: ${e}.`);
        }
    };

    that.debug = (source, event, meta) => {
        const logEvent = { source, event, meta };
        that.log(DEBUG, logEvent);
    };

    that.trace = (source, event, meta) => {
        const logEvent = { source, event, meta };
        that.log(TRACE, logEvent);
    };

    that.info = (source, event, meta) => {
        const logEvent = { source, event, meta };
        that.log(INFO, logEvent);
    };

    that.warn = (source, event, meta) => {
        const logEvent = { source, event, meta };
        that.log(WARNING, logEvent);
    };

    that.error = (source, event, meta) => {
        const logEvent = { source, event, meta };
        that.log(ERROR, logEvent);
    };

    // ************************************
    // Public function: close()
    // Closes the logger. No use case of this yet, but need to check.
    // ************************************

    that.close = () => {
        // ToDO TBD - reset all event logger properties such as eventLoggerToken, logID(risks?), uniqueSequence. Check risks.
    };

    that.revalidate = () => {
        // ToDO TBD - revalidate the eventLoggerToken by either reissuing another token or extending the current token validity
        // Need to check if logId and uniqueSequence should be preserved
    };

    that.processBufferEvents = () => {
        for (let i = 0; i < that.eventBuffer.length; i++) {
            const postEvent = that.eventBuffer[i];
            /*
            if(that.clientId && postEvent && postEvent.key){
               postEvent.key.clientId = that.clientId;
            }
            */
            const xhttpBuffer = new XMLHttpRequest();
            xhttpBuffer.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    Logger.info(this.responseText);
                } else {
                    Logger.error(`Connection to Event Server did not establish. Status: ${this.status}`);
                }
            };
            xhttpBuffer.open('POST', `https://${that.eventServer.url}/event`, true);
            xhttpBuffer.setRequestHeader('Content-Type', 'application/json');
            xhttpBuffer.setRequestHeader('eventToken', that.eventLoggerToken);
            xhttpBuffer.send(JSON.stringify(postEvent));
        }
    };

    that.setClientId = (clientId) => {
        that.clientId = clientId;
    };

    that.setEventLoggerToken = (token) => {
        if (token) {
            that.eventLoggerToken = token;
            if (that.eventLoggerToken && that.eventServer && that.eventServer.url) {
                that.processBufferEvents();
            }
        }
    };

    return that;
};

const EL = EventLogger();

export default EL;



//////////////////
// WEBPACK FOOTER
// ./src/EventLogger.js
// module id = 10
// module chunks = 0